import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { LibraryItemHeaderComponent } from '../../../Common/library-item-header/library-item-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LIBRARY_TABS } from '../../../../models/enum';

@Component({
  selector: 'app-cost-summary-view',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    LibraryItemHeaderComponent,
    TranslatePipe
  ],
  templateUrl: './cost-summary-view.component.html',
  styleUrl: './cost-summary-view.component.scss'
})
export class CostSummaryViewComponent {

  @Output() unpinCostSummaryLibrary = new EventEmitter<LIBRARY_TABS>();
  @Output() closeCostSummaryLibrary = new EventEmitter<LIBRARY_TABS>();

  constructor() { }

  unpinLibrary() {
    this.unpinCostSummaryLibrary.emit(LIBRARY_TABS.CostSummaryView);
  }

  closeLibrary() {
    this.closeCostSummaryLibrary.emit(LIBRARY_TABS.CostSummaryView);
  }
}
